package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * `derived defaults { name [: Type] = expr ... }` 块。
 *
 * 与 [StateAst] 平级，但条目值是**完整表达式**（读 `state.*` / `derived.*` / 常量 / 内建函数），
 * 编译为运行时 [top.wcpe.allincore.dsl.ir.expr.ExprNode] 字节，由运行时包成响应式 Computed
 * （懒求值 + 自动多依赖追踪），可像 state 一样在元素表达式 / 插值里通过 `derived.x` 读取。
 *
 * 约束（语义层校验）：
 * - 表达式禁止赋值、禁止 await；
 * - derived 名不能与 state / session / persist 重名；
 * - 禁止自引用与循环依赖（A → B → A）。
 */
data class DerivedAst(
    val entries: List<DerivedEntry>,
    override val position: SourcePosition,
) : AstNode {

    /** 单条派生值条目。 */
    data class DerivedEntry(
        val name: String,
        /** 派生表达式（任意 [ExprAst]，非字面量限制）。 */
        val expr: ExprAst,
        val position: SourcePosition,
        /** 可选类型标注；与 state 一致，写了才进入 wire 与 runtime 校验。 */
        val type: TypeAst? = null,
    )
}
